import { compareFieldFacetOptions, getUniqueListByKey } from '../utils';
import { useGetFieldFacetOption } from './useGetFieldFacetOption';
import { useFieldFacets, useFieldType } from '../../../hooks';

export const useFieldFacetTypeaheadOptions = () => {
  const { facets } = useFieldFacets();
  const fieldType = useFieldType();
  const getFieldFacetOption = useGetFieldFacetOption();
  const uniqueFieldFacets = getUniqueListByKey(facets, 'term');
  return uniqueFieldFacets
    .map(getFieldFacetOption)
    .sort((a, b) => compareFieldFacetOptions(a, b, fieldType));
};
